import React from 'react';

function tipKind(tip) {
  const s = String(tip || '').toLowerCase();
  if (/water|hydrat|moist|drink/.test(s)) return 'water';
  if (/sun|spf|uv|shade/.test(s)) return 'sun';
  if (/sleep|rest|night/.test(s)) return 'sleep';
  if (/diet|food|eat|nutrition/.test(s)) return 'diet';
  if (/clean|wash|gentle|exfol/.test(s)) return 'cleanse';
  if (/patch|test|product/.test(s)) return 'patch';
  return 'spark';
}

function TipGlyph({ kind }) {
  const common = {
    width: 15,
    height: 15,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1.9',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };
  switch (kind) {
    case 'water':
      return <svg {...common}><path d="M12 3s6 6.2 6 10a6 6 0 1 1-12 0c0-3.8 6-10 6-10z" /></svg>;
    case 'sun':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      );
    case 'sleep':
      return <svg {...common}><path d="M21 14.5A8.5 8.5 0 1 1 9.5 3 7 7 0 0 0 21 14.5z" /></svg>;
    case 'diet':
      return <svg {...common}><path d="M12 3v18M8 7c0 2 1.5 3 4 3s4-1 4-3M8 17c2-1 6-1 8 0" /></svg>;
    case 'cleanse':
      return <svg {...common}><path d="M7 10c0-3 2-5 5-5s5 2 5 5v8H7v-8z" /><path d="M9 21h6" /></svg>;
    case 'patch':
      return <svg {...common}><circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" /></svg>;
    default:
      return <svg {...common}><path d="M12 3l1.5 5.5L19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5L12 3z" /></svg>;
  }
}

export default function SkinReportTips({ tips = [], loading = false }) {
  if (loading) {
    return (
      <div className="skin-routine-summary-loading">
        <div className="loading-spinner" />
        <p className="skin-routine-summary-loading-text">Generating tips...</p>
      </div>
    );
  }

  if (!tips.length) {
    return <p className="skin-report-empty">Tips will appear based on your scan.</p>;
  }

  return (
    <ul className="skin-report-tips-list">
      {tips.map((tip, idx) => {
        const kind = tipKind(tip);
        return (
          <li key={`tip-${idx}`}>
            <span className={`skin-report-tips-icon skin-report-tips-icon--${kind}`} aria-hidden="true">
              <TipGlyph kind={kind} />
            </span>
            <span>{tip}</span>
          </li>
        );
      })}
    </ul>
  );
}
